// extracted by mini-css-extract-plugin
module.exports = {"nameChar":"ImageFallback_nameChar__FfO5X"};